module.exports = __webpack_public_path__ + "static/media/sosin-classes-logo.c35e28fd.png";